import { useState, useEffect } from 'react';

function ButtonSelectField(props: {
    id: string;
    label: string;
    extra?: string;
    state?: string;
    disabled?: boolean;
    onChange?: (value: string) => void;
    value?: string;
    options: string[];
    required?: boolean;
    columns?: number; // Number of columns in grid
}) {
    const {
        label,
        id,
        extra,
        state,
        disabled,
        onChange,
        value,
        options,
        required,
        columns = 2,
    } = props;

    const [selectedValue, setSelectedValue] = useState<string>(value || '');

    useEffect(() => {
        if (value !== undefined) {
            setSelectedValue(value);
        }
    }, [value]);

    const handleOptionClick = (option: string) => {
        if (disabled) return;
        setSelectedValue(option);
        if (onChange) {
            onChange(option);
        }
    };

    return (
        <div className={`${extra}`}>
            <label
                htmlFor={id}
                className="text-sm font-semibold text-gray-700"
            >
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <div
                className={`mt-2.5 grid gap-3 ${
                    columns === 2 ? 'grid-cols-2' :
                    columns === 3 ? 'grid-cols-3' :
                    columns === 4 ? 'grid-cols-4' :
                    'grid-cols-2'
                }`}
            >
                {options.map((option, index) => (
                    <button
                        key={index}
                        type="button"
                        onClick={() => handleOptionClick(option)}
                        disabled={disabled}
                        className={`
                            relative px-4 py-3.5 text-sm font-medium rounded-xl border-2 transition-all duration-200
                            focus:outline-none focus:ring-4 focus:ring-brand-100
                            ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
                            ${selectedValue === option
                                ? 'border-brand-500 bg-brand-50 text-brand-700 shadow-md shadow-brand-500/20'
                                : state === 'error'
                                ? 'border-red-200 bg-white text-gray-700 hover:border-red-300 hover:bg-red-50'
                                : 'border-gray-200 bg-white text-gray-700 hover:border-brand-300 hover:bg-brand-50/50'
                            }
                        `}
                    >
                        {selectedValue === option && (
                            <div className="absolute top-2 right-2">
                                <svg className="w-4 h-4 text-brand-600" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                </svg>
                            </div>
                        )}
                        {option}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default ButtonSelectField;
